/* ============================================
   Wavian Theme — JavaScript
   Design system: wavianusa.com
   ============================================ */

(function() {
  'use strict';

  /* --- Header: Transparent → Solid on Scroll --- */
  var header = document.querySelector('.sb-site-header');
  var headerHeight = 120;
  var scrolledClass = 'sb-header--scrolled';

  function handleHeaderScroll() {
    if (!header) return;
    if (window.pageYOffset > 60) {
      header.classList.add(scrolledClass);
    } else {
      header.classList.remove(scrolledClass);
    }
  }

  window.addEventListener('scroll', handleHeaderScroll, { passive: true });
  handleHeaderScroll(); // initial check

  /* --- Mobile Nav Toggle --- */
  var mobileToggle = document.querySelector('.sb-mobile-toggle');
  var mobileNav = document.querySelector('.sb-mobile-nav');
  var mobileOverlay = document.querySelector('.sb-mobile-overlay');

  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('sb-mobile-nav--open');
    if (mobileOverlay) mobileOverlay.classList.remove('sb-mobile-overlay--visible');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('sb-mobile-nav--open');
    if (mobileOverlay) mobileOverlay.classList.add('sb-mobile-overlay--visible');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = mobileNav && mobileNav.classList.contains('sb-mobile-nav--open');
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileNav);
  }

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.sb-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.sb-faq-item');
      var wasActive = item.classList.contains('sb-active');
      var answer = item.querySelector('.sb-faq-a');

      // Close all items in this FAQ section
      var faqList = item.closest('.sb-faq-list');
      if (faqList) {
        faqList.querySelectorAll('.sb-faq-item.sb-active').forEach(function(openItem) {
          openItem.classList.remove('sb-active');
          var openAnswer = openItem.querySelector('.sb-faq-a');
          if (openAnswer) openAnswer.style.maxHeight = null;
          var openBtn = openItem.querySelector('.sb-faq-q');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle current
      if (!wasActive) {
        item.classList.add('sb-active');
        if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* --- Sticky Bottom Bar --- */
  var stickyBar = document.querySelector('.sb-sticky-bar');
  if (stickyBar) {
    var stickyThreshold = 800;

    function handleStickyBar() {
      if (window.pageYOffset > stickyThreshold) {
        stickyBar.classList.add('sb-bar-visible');
      } else {
        stickyBar.classList.remove('sb-bar-visible');
      }
    }

    window.addEventListener('scroll', handleStickyBar, { passive: true });
    handleStickyBar();
  }

  /* --- Scroll Animations (Intersection Observer) --- */
  var fadeElements = document.querySelectorAll('.sb-fade-up');
  if (fadeElements.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sb-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    fadeElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* --- Quantity Selectors --- */
  document.querySelectorAll('.sb-qty').forEach(function(selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('[data-action="minus"]');
    var plus = selector.querySelector('[data-action="plus"]');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  /* --- Product Gallery Thumbnails --- */
  document.querySelectorAll('.sb-gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var gallery = this.closest('.sb-product-gallery');
      var mainImg = gallery ? gallery.querySelector('.sb-gallery-main') : null;
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
        mainImg.srcset = '';
        gallery.querySelectorAll('.sb-gallery-thumb').forEach(function(t) {
          t.classList.remove('sb-thumb-active');
        });
        this.classList.add('sb-thumb-active');
      }
    });
  });

  /* --- Product Variant Selection --- */
  var variantRadios = document.querySelectorAll('.sb-variant-radio');
  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var form = this.closest('form');
      if (!form) return;

      var productJson = form.dataset.product;
      if (!productJson) return;

      try {
        var product = JSON.parse(productJson);

        // Gather the selected value for each option group from checked radios
        var selectedOptions = [];
        var optionGroups = form.querySelectorAll('.sb-product-option');
        optionGroups.forEach(function(group) {
          var checked = group.querySelector('.sb-variant-radio:checked');
          if (checked) selectedOptions.push(checked.value);
        });

        // Update the option label text (e.g. "Pack: [25-Pack]")
        var optionIndex = this.name.replace('option', '') - 1;
        var selectedLabel = document.getElementById('option-' + (optionIndex + 1) + '-selected');
        if (selectedLabel) {
          var cleanVal = this.value.replace(/[\[\]]/g, '')
            .replace('BULK x250 Wavian Cans', 'Bulk 250-Pack')
            .replace('10-pack', '10-Pack');
          selectedLabel.textContent = cleanVal;
        }

        var variant = product.variants.find(function(v) {
          return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
        });

        if (variant) {
          var variantInput = form.querySelector('[name="id"]');
          var infoWrap = form.closest('.sb-product-info, .sb-product-card');
          var priceEl = infoWrap ? infoWrap.querySelector('.sb-product-info__price, .sb-prod-price, .sb-product-price') : null;
          var compareEl = infoWrap ? infoWrap.querySelector('.sb-product-info__compare') : null;
          var saveBadge = infoWrap ? infoWrap.querySelector('.sb-product-info__save-badge') : null;
          var submitBtn = form.querySelector('[type="submit"]');

          if (variantInput) variantInput.value = variant.id;
          if (priceEl) priceEl.textContent = '$' + (variant.price / 100).toFixed(2);

          // Update compare-at price and save badge
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (compareEl) {
              compareEl.textContent = '$' + (variant.compare_at_price / 100).toFixed(2);
              compareEl.style.display = '';
            }
            if (saveBadge) {
              saveBadge.textContent = 'Save $' + ((variant.compare_at_price - variant.price) / 100).toFixed(2);
              saveBadge.style.display = '';
            }
          } else {
            if (compareEl) compareEl.style.display = 'none';
            if (saveBadge) saveBadge.style.display = 'none';
          }

          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          }

          // Update URL
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);

          // Update product image if variant has a featured image
          if (variant.featured_image && variant.featured_image.src) {
            var mainImage = document.querySelector('.sb-product-gallery__main img, .sb-product-main-img');
            if (mainImage) {
              mainImage.src = variant.featured_image.src;
              mainImage.srcset = '';
              if (variant.featured_image.alt) mainImage.alt = variant.featured_image.alt;
            }
          }
        }
      } catch (e) {
        // silent fail
      }
    });
  });

  /* --- Add to Cart AJAX --- */
  window.WavianTheme = {
    addToCart: function(variantId, quantity) {
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      }).then(function(r) { return r.json(); });
    },

    updateCart: function(updates) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { return r.json(); });
    },

    getCart: function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    },

    formatMoney: function(cents) {
      return '$' + (cents / 100).toFixed(2);
    },

    updateCartCount: function(count) {
      document.querySelectorAll('.sb-cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    }
  };

  /* --- AJAX Add to Cart for product cards ---
     Now handled by cart-drawer.liquid's global form submit interceptor.
     The cart drawer intercepts all form[action="/cart/add"] submissions. */

  /* --- Lazy Video Embeds --- */
  document.querySelectorAll('.sb-video-play').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrapper = this.closest('.sb-video-embed');
      var videoUrl = this.dataset.videoUrl;
      if (!wrapper || !videoUrl) return;

      var iframe = document.createElement('iframe');
      iframe.src = videoUrl + '?autoplay=1';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none;';
      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    });
  });

})();
